<menu></menu>
<div id="container">
    <div class="form">
        <div class="header" table=true style="--cs:1fr 50px">
            <span>Listagem de Proprietários</span>
            <mat-icon (click)="edit(null)">note_add</mat-icon>
        </div>
        <div class="struct" id="struct">
            <buscacliente *ngIf="!loading" [data]="clientes" (sign)="edit($event)"></buscacliente>
        </div>
    </div>
</div>
<spinner *ngIf="loading"></spinner>